module.exports = __webpack_public_path__ + "static/media/70.0e939af3.jpg";